import {useState} from 'react';
import Square from './Square';

const Board = () => {
    const [state, setState] = useState(Array(9).fill(null));
    const [count, setCount] = useState(0);
    const [turn, setTurn] = useState('X')

    const changeTurn =() =>{
        if(turn ==='X')
        setTurn('O');
        if(turn ==='O')
        setTurn('X');
    }

    const checkWinner = () =>{
        const winnerlogic =[
            [0,1,2],
            [3,4,5],
            [6,7,8],
            [0,3,6],
            [1,4,7],
            [2,5,8],
            [0,4,8],
            [2,4,6]
        ];
        for(let logic of winnerlogic){
            const[a,b,c]=logic;
            if(state[a]!=null && state[a]===state[b] && state[b]===state[c]){
                setTimeout(
                    function(){
                        alert(`Winner is Player ${state[a]}`);
                        setState(Array(9).fill(null));
                        setCount(0);
                    },1000);
                return true;
            }
        }
        return false;
    }

    const handleClick = (index) =>{
        if(state[index]!==null){
            return;
        }
        else{
            state[index]=turn;
            changeTurn();
            var i = count + 1;
            setCount(i);
            checkWinner();
            checkDraw();
        }   
    }
    
    const checkDraw = ()=>{
        if(count!==8)
        {
            return;
        }
        else{
            setTimeout(
              function(){
                  alert("Match is draw");
                  setCount(0);
                  setState(Array(9).fill(null));
              } ,1000 
            );
            return;
        }
    }
        return(

            <div className="board-container">
            <h1><strong>TIC-TAC-TOE</strong></h1>
            <div className="board-row">
            <Square onClick={()=> handleClick(0)} value={state[0]}/>
            <Square onClick={()=> handleClick(1)} value={state[1]}/>
            <Square onClick={()=> handleClick(2)} value={state[2]}/>
            </div>
            <div className="board-row">
            <Square onClick={()=> handleClick(3)} value={state[3]}/>
            <Square onClick={()=> handleClick(4)} value={state[4]}/>
            <Square onClick={()=> handleClick(5)} value={state[5]}/>
            </div>
            <div className="board-row">
            <Square onClick={()=> handleClick(6)} value={state[6]}/>
            <Square onClick={()=> handleClick(7)} value={state[7]}/>
            <Square onClick={()=> handleClick(8)} value={state[8]}/>
            </div>
            <div>
            winner : {checkWinner}<br/>
            draw count : {count}
            </div>
            </div>
            );
        
};


export default Board;
